<div
  class="sfa-header-container pinned"
  [ngStyle]="{'background-color': (sfaHeaderSvc.previewColor$ | async) || (bgColor$ | async)}"
  *ngIf="isArchitecture() && sfaHeaderSvc.isPinned"
  (contextmenu)="onRightClick($event, {itemType: itemTypes.INFO})">
  <ng-container *ngTemplateOutlet="content; context: {header: headerData$ | async}"></ng-container>
  <div
    class="legend-block"
    [ngClass]="{
      'view-mode': (isViewMode$ | async),
      'hidden-items':
        !(headerData$ | async).legendItems || !(headerData$ | async).legendItems.length
    }">
    <div
      class="legend-content"
      #resContainerRef
      [dragula]="bagPrefix"
      [dragulaModel]="(headerData$ | async).legendItems">
      <ng-container *ngFor="let item of (headerData$ | async).legendItems; index as $i">
        <div
          class="legend-item"
          [ngClass]="{
            'legend-item-line': item.itemType === 'line',
            'legend-item-card': item.itemType === 'card',
            'legend-item-resource': item.itemType === 'resource'
          }"
          [attr.data-id]="item.mxKey"
          [attr.data-index]="$i"
          [matTooltip]="item.description || item.text | decodeHtml"
          matTooltipShowDelay="400"
          matTooltipHideDelay="400"
          [matTooltipPosition]="'below'"
          [matTooltipClass]="{'tooltip-breaker': true}"
          (contextmenu)="onRightClick($event, item)">
          <!--   Line     -->
          <p *ngIf="item.itemType === 'line'" class="legend-text">{{ item.text | decodeHtml }}</p>
          <div *ngIf="item.itemType === 'line'" class="legend-line-container">
            <mat-icon
              *ngIf="item.style.startArrow !== 'none'"
              class="fl-end"
              appDynamicCSSProperties
              [propertyConfig]="item.dynamicStyle.start"
              [svgIcon]="FL_END_MAPPER[item.style.startArrow]"></mat-icon>
            <div class="legend-line" [ngStyle]="item.style"></div>
            <mat-icon
              *ngIf="item.style.endArrow !== 'none'"
              class="fl-end"
              appDynamicCSSProperties
              [propertyConfig]="item.dynamicStyle.end"
              [svgIcon]="FL_START_MAPPER[item.style.endArrow]"></mat-icon>
          </div>

          <!--   Card     -->
          <p *ngIf="item.itemType === 'card'" class="legend-text" [ngStyle]="item.style">
            {{ item.text | decodeHtml }}
          </p>

          <!--   Resource     -->
          <div
            *ngIf="item.itemType === 'resource'"
            class="legend-icon"
            [style.backgroundImage]="safeImageUrl(item.image)">
            {{ item.image ? '' : (item.text[0] | decodeHtml) }}
          </div>
          <p *ngIf="item.itemType === 'resource'" class="legend-text">
            {{ item.text | decodeHtml }}
          </p>

          <!--   Remove icon     -->
          <span class="legend-item-remove">
            <mat-icon svgIcon="close" (click)="deleteLegendItem(item)"></mat-icon>
          </span>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div
  style="visibility: hidden; position: fixed"
  [style.left]="menuCoords.x"
  [style.top]="menuCoords.y"
  [matMenuTriggerFor]="rightMenu"></div>

<input
  type="file"
  accept="image/*"
  #file
  (change)="fileChangeEvent($event, file)"
  style="display: none" />

<mat-menu #rightMenu="matMenu">
  <ng-template matMenuContent let-item="item" let-options="options">
    <button
      mat-menu-item
      *ngIf="options.edit !== optionDisplayTypes.HIDE"
      [disabled]="options.edit === optionDisplayTypes.DISABLE"
      (click)="openEditItem(item)">
      {{ 'POPUPS.LEGEND_ITEM_EDIT' | translate }}
    </button>

    <button
      mat-menu-item
      *ngIf="options.remove !== optionDisplayTypes.HIDE"
      [disabled]="options.remove === optionDisplayTypes.DISABLE"
      (click)="deleteLegendItem(item)">
      {{ 'POPUPS.LEGEND_ITEM_REMOVE' | translate }}
    </button>

    <button
      mat-menu-item
      *ngIf="options.uploadLogo !== optionDisplayTypes.HIDE"
      [disabled]="options.uploadLogo === optionDisplayTypes.DISABLE"
      (click)="file.click()">
      {{ 'POPUPS.LEGEND_LOGO_UPLOAD' | translate }}
    </button>

    <button
      mat-menu-item
      *ngIf="options.changeLogo !== optionDisplayTypes.HIDE"
      [disabled]="options.changeLogo === optionDisplayTypes.DISABLE"
      (click)="file.click()">
      {{ 'POPUPS.LEGEND_LOGO_CHANGE' | translate }}
    </button>

    <button
      mat-menu-item
      *ngIf="options.removeLogo !== optionDisplayTypes.HIDE"
      [disabled]="options.removeLogo === optionDisplayTypes.DISABLE"
      (click)="removeLogo()">
      {{ 'POPUPS.LEGEND_LOGO_REMOVE' | translate }}
    </button>

    <button
      mat-menu-item
      *ngIf="options.changeBackground !== optionDisplayTypes.HIDE"
      [disabled]="options.changeBackground === optionDisplayTypes.DISABLE"
      (click)="changeBackground()">
      {{ 'POPUPS.LEGEND_CHANGE_BACKGROUND' | translate }}
    </button>
  </ng-template>
</mat-menu>

<ng-template #content let-header="header">
  <div
    class="info-logo"
    (contextmenu)="onRightClick($event, {itemType: itemTypes.LOGO, header: header})">
    <div
      class="info-logo--placeholder"
      *ngIf="!header.logo && !blob"
      [ngStyle]="{
        'background-color': (sfaHeaderSvc.previewColor$ | async) || (bgColor$ | async)
      }"></div>
    <img
      *ngIf="header.logo || blob"
      [src]="blob || header.logo"
      class="info-logo--picture"
      alt="logo" />
  </div>
  <div class="info-block" #infoBlock>
    <div class="info-title">{{ (headerData$ | async).title | decodeHtml }}</div>

    <div
      class="info-description"
      [matTooltip]="(headerData$ | async).description | decodeHtml"
      matTooltipShowDelay="400"
      matTooltipHideDelay="400"
      [matTooltipPosition]="'below'"
      [matTooltipClass]="{'tooltip-breaker': true}">
      {{ (headerData$ | async).description | decodeHtml }}
    </div>

    <svg
      #svgCurve
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 119 398"
      fill="none"
      class="svg-curve"
      preserveAspectRatio="none"
      [ngStyle]="{fill: (sfaHeaderSvc.previewColor$ | async) || (bgColor$ | async)}">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.510742 398C41.6728 342.177 66 273.179 66 198.5C66 124.266 41.962 55.6462 1.24528 0L118.999 0V398H0.510742Z" />
    </svg>
  </div>
</ng-template>
